import {
  GET_OPERATORS_CATALOG,
  GET_OPERATORS_CATALOG_SUCCESS,
  GET_OPERATORS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getOperatorsCatalogRed = (state: any, actions: any) => {
  switch (actions.type) {
    case GET_OPERATORS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_OPERATORS_CATALOG_SUCCESS:
      return {
        ...state,
        data: actions.payload,
        loading: false,
        error: null,
      };
    case GET_OPERATORS_CATALOG_ERROR:
      return {
        loading: false,
        error: null,
        data: null,
      };
    default:
      return state;
  }
};
